import {
  FETCH_MONTHLY_DATA_POINTS_START,
  FETCH_MONTHLY_DATA_POINTS_SUCCESS,
  FETCH_MONTHLY_DATA_POINTS_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  dataPoints: [],
  isFetching: true,
  errorMessage: '',
}

const monthlyDataPointsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MONTHLY_DATA_POINTS_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_MONTHLY_DATA_POINTS_SUCCESS:
      return {
        ...state,
        dataPoints: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_MONTHLY_DATA_POINTS_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default monthlyDataPointsReducer
